import React from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import {Icon} from 'react-icons-kit';
import {menu} from 'react-icons-kit/feather/menu';
import {eye} from 'react-icons-kit/feather/eye';
import {arrowUpRight} from 'react-icons-kit/feather/arrowUpRight'

function Details() {
    return (
        <div className="dashboard-content">
            <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div>
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Seller Management</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="#" className="btn btn-primary addSeller"><Icon className="eye" icon={eye} size={18}/> View All</NavLink>
                        <NavLink to="#" className="btn btn-primary addSeller"><Icon className="arrowUpRight" icon={arrowUpRight} size={18}/> Edit</NavLink>
                    </div>
                </div>
                <div className="detailsBox">
                    <div className="row">
                        <div className="col-lg-6">
                            <h4 className="text-primary h6 fw-bold">Seller Information</h4>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>First Name</th>
                                            <td>Vahid</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>Ali</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>Ali</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>Ali</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>Ali</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h4 className="text-primary h6 fw-bold">Other Information</h4>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>First Name</th>
                                            <td>Vahid</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>Ali</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>Ali</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>Ali</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>Ali</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    
                </div>     
            </div>
        </div>
    );
  }
export default Details;
